import useColumnsOrdersStore from "@/modules/sales/home/store/useColumnsOrdersStore";
import { usePurchasingStore } from "@store/purchases/addPurchase/usePurchasingStore";
import { create } from "zustand";

const useAuthStore = create((set, get) => {
  // GROW-119: Access token is NOT persisted in localStorage to prevent XSS exfiltration.
  // The refresh token lives in an HttpOnly cookie (managed by the backend).
  // On page reload the existing silent-refresh flow in axios.setup.js will recover the session.
  let storedUser = null;
  let storedExpiresIn = null;
  let storedPermissions = [];
  if (typeof window !== "undefined") {
    storedExpiresIn = localStorage.getItem("expiresIn");
    storedUser = localStorage.getItem("user");
    storedPermissions = localStorage.getItem("permissions");
    storedUser =
      typeof storedUser === "string" && storedUser.trim() !== ""
        ? JSON.parse(storedUser)
        : null;
    storedPermissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  }
  return {
    token: null, // GROW-119: token lives in memory only, never in localStorage
    user: storedUser,
    permissions: storedPermissions,
    expiresIn: storedExpiresIn || null,
    showSessionExpiredModal: false,
    setShowSessionExpiredModal: (value) =>
      set({ showSessionExpiredModal: value }),
    setAuthData: (expiresIn, token, permissions, newUser) => {
      set({
        expiresIn: expiresIn,
        token: token,
        permissions: permissions,
        user: newUser,
      });
      if (typeof window !== "undefined") {
        // GROW-119: token is intentionally NOT saved to localStorage
        localStorage.setItem("tokenTimestamp", Date.now().toString());
        localStorage.setItem("expiresIn", expiresIn);
        localStorage.setItem("user", JSON.stringify(newUser));
        localStorage.setItem("permissions", JSON.stringify(permissions));
      }
    },
    updatePermissions: (updatedUser) => {
      const { user } = get();
      if (!user || String(user.id) !== String(updatedUser.id)) return;
      const permissions = updatedUser.permissions.SPR617 ?? updatedUser.permissions;
      const nextUser = { ...user, ...updatedUser };
      if (typeof window !== "undefined") {
        localStorage.setItem("user", JSON.stringify(nextUser));
        localStorage.setItem("permissions", JSON.stringify(permissions));
      }
      set({ permissions, user: nextUser });
    },
    clearAuthData: () => {
      const { setOrders, setEditableRows } = usePurchasingStore.getState();
      const { resetHiddenColumns } = useColumnsOrdersStore.getState();

      setOrders([]);
      setEditableRows({});
      resetHiddenColumns();

      set({ token: null, permissions: [], user: null, expiresIn: null });
      if (typeof window !== "undefined") {
        localStorage.removeItem("expiresIn");
        localStorage.removeItem("tokenTimestamp");
        localStorage.removeItem("user");
        localStorage.removeItem("permissions");
        localStorage.removeItem("purchasing-store");
        localStorage.removeItem("ordersHiddenColumns");
        setOrders([]);
        setEditableRows({});
      }
    },
    clearPermissions: () => {
      set({ permissions: [] });
      if (typeof window !== "undefined") {
        localStorage.removeItem("permissions");
      }
    },
  };
});
export default useAuthStore;
